/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CreateApiTokenDto { 
    name: string;
    description?: string;
    /**
     * number of days to expire
     */
    expiresIn?: number;
}

